/**
 * フォーム送信前の確認ダイアログを表示するユーティリティモジュール
 */

/**
 * フォーム送信前に確認ダイアログを表示します。
 * @param {Event} event - フォーム送信イベント
 * @param {Object} options - オプション設定
 * @param {string} options.submitButtonTarget - 送信ボタンのdata-target属性値（オプション）
 * @param {number} options.disableTimeout - ボタンを無効化する時間（ミリ秒、デフォルト: 3000）
 * @returns {boolean} 確認でキャンセルされた場合はfalseを返します。
 */
export function confirmBeforeSubmit(event, options = {}) {
  const form = event?.target
  if (!form) return true

  const message = form.dataset.confirmMessage
  if (!message) return true

  if (!window.confirm(message)) {
    event.preventDefault()
    event.stopImmediatePropagation()
    return false
  }

  // 送信ボタンを一時的に無効化
  if (options.submitButtonTarget) {
    const submitButton = form.querySelector(`[data-${options.submitButtonTarget}]`)
    if (submitButton) {
      submitButton.disabled = true
      const timeout = options.disableTimeout || 3000
      setTimeout(() => {
        submitButton.disabled = false
      }, timeout)
    }
  }

  return true
}
